import { useCallback } from 'react';

import useTranslation from '../../../hooks/useTranslation';
import TranslationsConfigType from '../../../translations/translationType';
import validateSSN from '../../../utils/validation/validateSSN';
import { UseValidateHook } from '../../../utils/validation/validateTypes';
import EfakturaSharingState from './state';

export type EFakturaError = {
    name?: string;
    ssn?: string;
    amountSelected?: string;
    selected?: string;
};

export const defaultErrors: EFakturaError = {
    name: undefined,
    ssn: undefined,
    amountSelected: undefined,
    selected: undefined,
};

export const validateUser = (translated: TranslationsConfigType, formState: EfakturaSharingState) => {
    const { ssn, name, amountSelected } = formState;
    const {
        eFakturaSharing: { validationErrors },
    } = translated;
    const errors: Partial<EFakturaError> = {
        name: undefined,
        ssn: undefined,
        amountSelected: undefined,
    };

    const ssnError = validateSSN(ssn ?? '');
    errors.ssn = typeof ssnError === 'string' ? validationErrors.ssn[ssnError] : undefined;

    if (!name) {
        errors.name = validationErrors.name.required;
    }

    if (!amountSelected) {
        errors.amountSelected = validationErrors.amountSelected.required;
    }

    return errors;
};

export const validateSelectedEfakturas = (translated: TranslationsConfigType, formState: EfakturaSharingState) => {
    const { amountSelected, selected } = formState;
    const {
        eFakturaSharing: { validationErrors },
    } = translated;
    const errors: Partial<EFakturaError> = {
        selected: undefined,
    };
    if (amountSelected === 'some' && (!selected || selected?.length === 0)) {
        errors.selected = validationErrors.selected.tooFewSelected;
    }

    return errors;
};

export const validate =
    (translated: TranslationsConfigType) =>
    (formState: EfakturaSharingState): EFakturaError => {
        const userErrors = validateUser(translated, formState);
        const selectedErrors = validateSelectedEfakturas(translated, formState);
        return { ...defaultErrors, ...selectedErrors, ...userErrors };
    };

const useValidate: UseValidateHook<EfakturaSharingState, EFakturaError> = () => {
    const translated = useTranslation();
    return useCallback(async (state) => validate(translated)(state), [translated]);
};

export default useValidate;
